import React from 'react'
import { Button } from 'reactstrap'

export default function ChooseFileButton({handleClick}) {
  return (
    <Button size="sm" color="primary" onClick={handleClick}>Choose an artwork</Button>
  )
}
